import { render, staticRenderFns } from "./student_info.vue?vue&type=template&id=1ac4c23f&scoped=true&"
import script from "./student_info.vue?vue&type=script&lang=js&"
export * from "./student_info.vue?vue&type=script&lang=js&"
import style0 from "./student_info.vue?vue&type=style&index=0&id=1ac4c23f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac4c23f",
  null
  
)

export default component.exports